import {
  Button,
  CircularProgress,
  makeStyles,
  Typography,
} from '@material-ui/core';
import { DateTime } from 'luxon';
import React from 'react';
import styled from 'styled-components';

import useTireActions from 'core/hooks/useTireActions';
import { Thousands } from 'Elements/Formats';
import {
  Body,
  Column,
  GridTable,
  Header,
  Row as GridRow,
} from 'Elements/GridTable';

import { Schema } from './schema';

const Row = styled(GridRow)`
  grid-template-columns: 200px minmax(150px, 1fr) 100px 100px;
`;

const CenterColumn = styled(Column)`
  grid-column: 1 / 6;
  display: flex;
  justify-content: center;
`;

type Props = {
  params: Schema;
};

const useStyles = makeStyles(theme => ({
  h5: {
    lineHeight: 1.5
  }
}));

export default function ActionsTable({ params }: Props) {
  const classes = useStyles();
  const { data, loading, hasMore, loadMore } = useTireActions(params);

  return (
    <GridTable>
      <Header>
        <Row>
          <Column>Päivämäärä</Column>
          <Column>Seloste</Column>
          <Column>Ura</Column>
          <Column>KM</Column>
        </Row>
      </Header>

      <Body>
        {data.map(action => (
          <Row key={action.id}>
            <Column>
              <Typography variant="h5" className={classes.h5}>
                {DateTime.fromSQL(action.created_at).toFormat('dd.MM.yyyy')}
              </Typography>
              <Typography variant="subtitle1">
                ID: {action.tire_id.substr(0, 8)}
              </Typography>
            </Column>

            <Column>
              <Typography variant="body1">{action.as_text}.</Typography>
              <Typography variant="subtitle1">
                {action.surface.product.name} @{' '}
                {action.location && action.location.name}
                {action.slot && action.location && ' - '}
                {action.slot && action.slot.title}
              </Typography>
            </Column>
            <Column>{+action.track_depth} mm</Column>
            <Column>
              <Thousands>{action.kilometers}</Thousands>
            </Column>
          </Row>
        ))}
        <Row>
          <CenterColumn>
            {loading && <CircularProgress />}

            {!loading && hasMore && (
              <Button variant="contained" color="primary" onClick={loadMore}>
                Lataa lisää
              </Button>
            )}

            {!loading && !hasMore && (
              <Typography variant="subtitle1">
                Ei enempää toimenpiteitä
              </Typography>
            )}
          </CenterColumn>
        </Row>
      </Body>
    </GridTable>
  );
}
